// Real Formulas — conversion measurement layer
// Dependency-free. Publishes standard Shopify web-pixel events AND pushes
// to window.dataLayer so a GA4 tag (or any analytics stack) can consume them.
// No external scripts load by default; this is the instrumentation only.
(function () {
  'use strict';

  var GA4_ID = (window.RF_ANALYTICS && window.RF_ANALYTICS.ga4) || '';

  function push(event, params) {
    // Shopify web pixels (Customer Events / checkout analytics)
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      try { Shopify.analytics.publish(event, params || {}); } catch (e) {}
    }
    // GA4-ready dataLayer
    if (window.dataLayer && window.dataLayer.push) {
      var payload = { event: event };
      if (params) { for (var k in params) payload[k] = params[k]; }
      window.dataLayer.push(payload);
    }
  }

  function moneyCents(str) {
    if (!str) return 0;
    var n = parseFloat(String(str).replace(/[^0-9.\-]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  // ---- View item (PDP) ----
  var productJson = document.querySelector('[data-product-json]');
  if (productJson) {
    try {
      var prod = JSON.parse(productJson.textContent);
      push('view_item', {
        ecommerce: true,
        items: [{
          item_id: prod.variant_id,
          item_name: prod.title,
          price: prod.price / 100,
          currency: 'USD'
        }]
      });
    } catch (e) {}
  }

  // ---- Add to cart / subscribe & save starter ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute || !form.hasAttribute('data-add-to-cart-form')) return;
    var idInput = form.querySelector('[name="id"]') || form.querySelector('[data-variant-id]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var planInput = form.querySelector('[data-selling-plan-input]');
    var sellingPlan = planInput && planInput.value ? planInput.value : null;
    var variantId = idInput ? idInput.value : null;
    if (!variantId) return;

    var priceEl = document.querySelector('[data-price]');
    var price = priceEl ? moneyCents(priceEl.textContent) : 0;
    var title = document.title.replace(/ — Real Formulas.*$/, '') || 'Product';

    // Fire immediately (not waiting on the fetch) so no cart latency is lost.
    push(sellingPlan ? 'subscribe_and_save_started' : 'add_to_cart', {
      ecommerce: true,
      items: [{
        item_id: variantId,
        item_name: title,
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
        price: price / 100,
        currency: 'USD'
      }]
    });

    if (sellingPlan) {
      push('add_to_cart', { // still count it as an add-to-cart for parity
        ecommerce: true,
        subscription: true,
        items: [{ item_id: variantId, item_name: title, quantity: 1, price: price / 100 }]
      });
    }
  });

  // ---- Begin checkout (drawer checkout button) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-checkout], a[href*="/checkout"]');
    if (!btn) return;
    push('begin_checkout', { ecommerce: true });
  });

  // ---- Form / lead events ----
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.tagName) return;
    if (f.classList && f.classList.contains('wh-form__body')) push('generate_lead', { form: 'wholesale' });
    if (f.closest && f.closest('[data-ambassador-form]')) push('generate_lead', { form: 'ambassador' });
  });

  // ---- Scroll depth (PDP + home) — useful for where people bail ----
  (function scrollDepth() {
    var depthSent = {};
    var buckets = [25, 50, 75, 100];
    var root = document.documentElement;
    function report() {
      var docH = root.scrollHeight - window.innerHeight;
      if (docH <= 0) return;
      var pct = Math.round((window.scrollY / docH) * 100);
      buckets.forEach(function (b) {
        if (pct >= b && !depthSent[b]) {
          depthSent[b] = true;
          push('scroll_depth', { percent: b, page: location.pathname });
        }
      });
    }
    var t;
    window.addEventListener('scroll', function () {
      if (t) return;
      t = setTimeout(function () { t = null; report(); }, 200);
    }, { passive: true });
  })();
})();